import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { genericProjectLayout } from '@jira/platform__layouts-generic-project-layout/src/index.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectsComponentsResource } from '@jira/router-resources__projects-components/src/projectsComponentsResource.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { projectComponentsRedirectRoute } from '@jira/router-routes__project-components-routes/src/projectComponentsRedirectRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { ComponentsRedirect } from './ui/index.tsx';

export const projectComponentsRedirectRouteEntry: Route = createEntry(
	projectComponentsRedirectRoute,

	() => ({
		group: 'components',
		// eslint-disable-next-line no-restricted-syntax
		component: !__SERVER__ ? ComponentsRedirect : undefined,
		layout: genericProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getNavigationResources(),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			incidentExperimentTraitResource,
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			projectsComponentsResource,
			getConsolidationStateResource(),
		],

		forPaint: [LazyAtlassianNavigation],
		isRedirect: true,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
